import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({

    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        minWidth: '400px',
        minHeight: '180px',
        padding: '12px 28px 20px 28px',
    },

    topPanel: {
        display: 'flex',
        width: '100%',
        maxHeight: '80px',
        justifyContent: 'space-between',
        alignItems: 'center',
        margingTop: '16px',
        padding: '24px 18px 8px 18px',
    },

    message: {
        textAlign: 'center',
         marginBottom: '28px',
    },

    loadingAnimationBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '48px',
    },
});

export default styles;
export const useStyles = makeStyles(styles);
